// CONSTANTS
// const DIRECTORY_URL = $('body').data('directory-url');
const DIRECTORY_URL = document.body.getAttribute('data-directory-url') || '';
// const headlessAjax = $('body').data('mvc-ajax');
const headlessAjax = document.body.getAttribute('data-mvc-ajax') || '';
// const ajaxurl = $('body').data('ajaxurl');
const ajaxurl = document.body.getAttribute('data-ajaxurl') || '' ;

/* MOBILE MENU TRIGGER */
/* var mobileMenuTrigger = document.getElementById("mobileMenuTrigger");
// check if mobileMenuTrigger exists
if(mobileMenuTrigger){
    mobileMenuTrigger.addEventListener("click", function(){

        if(document.querySelector(".offcanvas-backdrop")){
            // disable offcanvas backdrop
            document.querySelector(".offcanvas-backdrop").classList.toggle("d-none");
        }
    });
}
 */
// Back to top
const backToTop = document.getElementById('backToTop');
if (backToTop) {
    backToTop.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
}

/* tabbed content */
// get all tabs
var tabElAll = document.querySelectorAll('button[data-bs-toggle="tab"]');
// check if element exist
if(tabElAll !== null){
    // loop all tabs
    tabElAll.forEach(function (tab) {
        tab.addEventListener('shown.bs.tab', function (event) {
            // add class
            event.target.classList.add(...[]);
            // remove class
            event.relatedTarget.classList.remove(...[]);
        })
    })
}

/* mobile menu */
mobileMenuTriggers();
function mobileMenuTriggers(){

    document.body.addEventListener('click', function(event) {
        if (event.target.matches('.mobile-menu-item.menu-item-has-children > a .dd-icon')) {
            event.preventDefault();
            event.target.parentNode.classList.toggle('active');
            event.target.parentNode.parentNode.querySelector('.sub-menu').classList.toggle('d-none');
        }
        else if (event.target.closest('.sub-menu-back')) {
            // $('.mmenu a').removeClass('bg-white fw-bold');
            let mmenu = document.querySelectorAll('.mmenu a');
            mmenu.forEach(function(item) {
                item.classList.remove('bg-white', 'fw-bold');
            });
            var backElement = event.target.closest('.sub-menu-back');
            backElement.parentNode.parentNode.parentNode.classList.toggle('d-none');
            backElement.parentNode.parentNode.parentNode.previousElementSibling.classList.toggle('active');
        }
        else if (event.target.matches('.mmenu a')) {
            event.preventDefault();
            var data = event.target.getAttribute('data-mtype');
            // $('.mmenu a').removeClass('bg-white fw-bold');
            let mmenu = document.querySelectorAll('.mmenu a');
            mmenu.forEach(function(item) {
                item.classList.remove('bg-white', 'fw-bold');
            });
            event.target.parentNode.parentNode.parentNode.classList.toggle('d-none');
            event.target.parentNode.parentNode.parentNode.parentNode.parentNode.querySelector('.mobile-menu-item.menu-item-has-children > a[data-mtype="' + data + '"]').click();
        }
    }, true);

}


/* desktop menu */
desktopMenuTriggers();
function desktopMenuTriggers(){
    document.body.addEventListener('mouseenter', function(event) {
        if (event.target.matches('.menu-item.menu-item-has-children.sdd')) {
            event.target.classList.add('active');
        }
    }, true);
    
    document.body.addEventListener('mouseleave', function(event) {
        if (event.target.matches('.menu-item.menu-item-has-children.sdd')) {
            event.target.classList.remove('active');
        }
    }, true);

    document.body.addEventListener('click', function(event) {
        // console.log(event);
        // event.preventDefault();
        if (event.target.matches('.menu-item.menu-item-has-children > a.dd-icon') || event.target.matches('.menu-item.menu-item-has-children > a.dd-icon > span') || event.target.matches('.menu-item.menu-item-has-children > a > i.dd-icon')) {
            event.preventDefault();
            let target = event.target;
            if(event.target.matches('.menu-item.menu-item-has-children > a.dd-icon > span') || event.target.matches('.menu-item.menu-item-has-children > a > i.dd-icon')){
                target = event.target.parentNode;
            }
            target.parentNode.classList.toggle('active');
            target.parentNode.querySelector('.sub-menu').classList.toggle('d-none');
        }
    }, true);
    
}

/**
 * Script for horizontal dragging
 */
 const dragScrollHorizontalElements = document.querySelectorAll('body .drag-scroll-horizontal');
 dragScrollHorizontalElements.forEach(dragScrollHorizontalElement => {
     // Position
     let pos = {
         left: 0,
         x: 0,
     };

     /**
      * On mouse move
      */
     const dragScrollMoveHandler = (e) => {
         const dx = (e.clientX ?? e.touches[0].clientX) - pos.x;
         dragScrollHorizontalElement.scrollLeft = pos.left - dx;
     }


     /**
      * On mouse down
      */
     const dragScrollDownHandler = (e) => {
         dragScrollHorizontalElement.style.cursor = 'grabbing';
         dragScrollHorizontalElement.style.userSelect = 'none';

         pos = {
             left: dragScrollHorizontalElement.scrollLeft,
             x: (e.clientX ?? e.touches[0].clientX),
         };

         document.addEventListener('mousemove', dragScrollMoveHandler);
         // document.addEventListener('touchmove', dragScrollMoveHandler);
         document.addEventListener('mouseup', dragScrollUpHandler);
         // document.addEventListener('touchend', dragScrollUpHandler);
     }

     /**
      * On mouse up
      */
     const dragScrollUpHandler = (e) => {
         document.removeEventListener('mousemove', dragScrollMoveHandler);
         // document.removeEventListener('touchmove', dragScrollMoveHandler);
         document.removeEventListener('mouseup', dragScrollUpHandler);
         // document.removeEventListener('touchend', dragScrollUpHandler);

         // dragScrollHorizontalElement.style.cursor = 'grab';
         // dragScrollHorizontalElement.style.removeProperty('user-select');
     }

     dragScrollHorizontalElement.addEventListener('mousedown', dragScrollDownHandler);
     // dragScrollHorizontalElement.addEventListener('touchsta/rt', dragScrollDownHandler);
 });


/*
 * LOAD THE MEGA MENU AFTER THE PAGE LOADS
 *
 */
/* document.addEventListener('DOMContentLoaded', () => {
    const scrollIntoIdElements = document.querySelectorAll('.scroll-into-id');
    if (scrollIntoIdElements.length) {
        const hash = window.location.hash;
        if (hash) {
            const element = document.getElementById(hash.replace('#', ''));
            // console.log(`Scroll into ${hash}`, element);
            if (element) {
                const offset = element.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({ top: offset - document.getElementById('header').offsetHeight, behavior: 'smooth' });
            }
        }
    }

    const gotoIdElements = document.querySelectorAll('.go-to-id');
    if (gotoIdElements.length) {
        gotoIdElements.forEach(item => {
            item.addEventListener('click', function (e) {
                e.preventDefault();
                const hash = item.getAttribute('href');
                if (hash) {
                    const element = document.getElementById(hash.replace('#', ''));
                    // console.log(`Scroll into ${hash}`, element);
                    if (element) {
                        const offset = element.getBoundingClientRect().top + window.scrollY;
                        window.scrollTo({ top: offset - document.getElementById('header').offsetHeight, behavior: 'smooth' });
                    }
                }
            });
        });
    }

    // Back to top
    const backToTop = document.getElementById('backToTop');
    if (backToTop) {
        backToTop.addEventListener('click', function () {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    }

    // Custom Mobile Filter
    // const customMobileModal = document.querySelector('.custom-filter-modal');
    // const customMobileFilterToggle = document.querySelectorAll('.custom-mobile-filter-trigger');
    // if(customMobileFilterToggle.length){
    //     customMobileFilterToggle.forEach(item => {
    //         item.addEventListener('click', function () {
    //             customMobileModal.classList.toggle('d-block');
    //         });
    //     });
    // }


    // Open Get a Quote Modal
    const quoteModal = document.getElementById('quoteModal') ? new bootstrap.Modal(document.getElementById('quoteModal')) : '';
    const quoteModalEl = document.getElementById('quoteModal');
    const getAquoteAnchors = document.querySelectorAll('a[href="#quoteModal"]');
    if (getAquoteAnchors.length) {
        getAquoteAnchors.forEach(item => {
            item.onclick = (e) => {
                e.preventDefault();
                // console.log('Quote Modal Link');
                if(quoteModalEl){
                    quoteModal.show();
                }
            }
        });
    }
}); */

// check if has scrolled then add class to header
window.addEventListener('scroll', function() {
    const scroll = window.scrollY || window.pageYOffset;
    const header = document.getElementById('header');

    if (scroll >= 100) {
        header.classList.add('scrolled');
    } else {
        header.classList.remove('scrolled');
    }
});

// Vanity Builder
const vanityBuilder = () => {

    // Wrap #infiniteoptions-container in a div with class .infiniteoptions-container
    const infiniteOptionsContainer = document.getElementById('infiniteoptions-container');
    
    if (!infiniteOptionsContainer) {
        return;
    }

    // 
    let vanityBuilderLayout = document.querySelector('[data-vanity-builder-layout]').getAttribute('data-vanity-builder-layout');
    
    if (infiniteOptionsContainer.innerHTML.trim().length == 0) {
        return;
    }

    // add class active -- to show the vanity builder
    document.getElementById('infiniteoptions-container').classList.add('active');

    if (String(vanityBuilderLayout).toLowerCase() === 'true') {
        infiniteOptionsContainer.classList.add('vanity-builder-section');
    } else {
        infiniteOptionsContainer.classList.add('vanity-builder-default');
        showBuyButtons();
        return;
    }
    // hide qty and form
    // const variantSelects = document.querySelector('variant-selects');
    // const productFormQuantity = document.querySelector('.product-form__quantity');
    const productForm = document.querySelector('.product-form > form');
    if (productForm) {
        // variantSelects.classList.add('d-none');
        // productFormQuantity.classList.add('d-none');
        // productForm.classList.add('d-none');

        let vanityAddToCartWrapper = document.querySelector('.vanity-builder-add-to-cart-wrapper');
        
        if(vanityAddToCartWrapper){
            // find a
            let vbutton = vanityAddToCartWrapper.querySelector('a');
            // remove disabled class
            vbutton.classList.remove('disabled');
            // change text 
            vbutton.innerText = 'Build Your Vanity';
        } else {
            // add div before product form
            const newDiv = document.createElement('div');
            newDiv.classList.add('vanity-builder-add-to-cart-wrapper');
            productForm.parentNode.insertBefore(newDiv, productForm);
            let vbHtml = `<div class="bg-light p-3">
                            <a href="#infiniteoptions-container" class="btn btn-primary w-100 fs-5">Build Your Vanity</a>
                        </div>`;
            newDiv.innerHTML = vbHtml;

        }

    }

    if (infiniteOptionsContainer) {
        // find closest .shopify-section
        const shopifySection = infiniteOptionsContainer.closest('.shopify-section');
        // anchor div before the shopify section
        // const anchorDiv = document.createElement('div');
        // anchorDiv.id = 'vanity-builder';
        // shopifySection.parentNode.insertBefore(anchorDiv, shopifySection);
        // create a div with class .infiniteoptions-container-wrapper after the shopify section
        const newWrapperDiv = document.createElement('div');
        newWrapperDiv.classList.add('infiniteoptions-container-wrapper');
        shopifySection.parentNode.insertBefore(newWrapperDiv, shopifySection.nextSibling);

        // move the whole infiniteOptionsContainer to the new wrapper div
        newWrapperDiv.appendChild(infiniteOptionsContainer);

        const wrapperDiv = document.createElement('div');
        wrapperDiv.classList.add('infiniteoptions-container', 'px-4', 'px-lg-3');
        infiniteOptionsContainer.parentNode.insertBefore(wrapperDiv, infiniteOptionsContainer);
        wrapperDiv.appendChild(infiniteOptionsContainer);

        // Append another div with class .infiniteoptions-sidebar
        const sidebarDiv = document.createElement('div');
        sidebarDiv.classList.add('infiniteoptions-sidebar');
        wrapperDiv.appendChild(sidebarDiv);
    }

    // header height
    const headerHeight = document.getElementById('header').offsetHeight + 20;
    const productTitle = document.querySelector('h1').innerText;
    const firstImage = document.querySelector('.gallery-main .keen-slider__slide:first-child img');
    const productImageSrc = firstImage ? firstImage.getAttribute('src') : '';

    // Build the sidebar Content
    const sidebarContent = `
        <div class="position-sticky" style="top: ${headerHeight}px;">
            <div class="sidebar-header">
                <h4 class="sidebar-title text-center fw-normal">Your Selection</h4>
            </div>
            <div class="sidebar-body p-3">
                ${productImageSrc ? `<div class="mb-3"><img src="${productImageSrc}" alt="${productTitle}" class="img-fluid"></div>` : ''}
                <h5 class="mb-1">${productTitle}</h5>
                <p class="mb-2 d-none">Customize your vanity by selecting your options.</p>
                <div id="vanity-information"></div>
                <div id="vanity-prices" class="mt-4"></div>
                <div class="position-relative mt-4">
                    <a class="btn btn-primary vanity-add-to-cart w-100 fs-md" href="">Add to Cart</a>
                    <div class="loading__spinner hidden"><svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg></div>
                </div>
            </div>
        </div>
    `;
    // append the sidebar content to the sidebar div
    const sidebarDiv = document.querySelector('.infiniteoptions-sidebar');
    if (sidebarDiv) {
        sidebarDiv.innerHTML = sidebarContent;
    }

    // Build the information based on the selected options
    let data = [];
    let toolTipLabels = document.querySelectorAll('.spb-label-tooltip');

    // loop through all the labels and add empty array to data
    toolTipLabels.forEach(item => {
        // 
        item.parentNode.classList.add('swatch-item');
        item.nextElementSibling.classList.add('swatch-item-content');

        // 
        const label = item.querySelector('label').innerHTML;
        
        // insert label to #vanity-information
        let labelContent = `
            <div class="sidebar-item border-bottom py-2 d-none" data-label="${label}">
                <span class="sidebar-label fs-sm fw-bold d-block">${label}:</span>
                <span class="sidebar-value"></span>
                <button type="button" class="btn btn-link text-danger remove-vanity-option p-0 fs-sm text-primary" aria-label="Remove ${label}"><i class="fas fa-times"></i></button>
            </div>
        `;

        document.getElementById('vanity-information').insertAdjacentHTML('beforeend', labelContent);
    });
    
    swatchMultipleSelect();
    vanityEventHandlers();
};

const vanityEventHandlers = () => {

    const mainContainer = document.querySelector('.infiniteoptions-container');
    let options = mainContainer.querySelectorAll('input[type="radio"], input[type="checkbox"]:not(fieldset input[type="checkbox"]), input[type="text"], input[type="number"], textarea');
    let optionsMultiple = mainContainer.querySelectorAll('fieldset input[type="checkbox"]');
    let optionsRadio = mainContainer.querySelectorAll('.swatch-item-content input[type="radio"]');
    let selectOptions = mainContainer.querySelectorAll('select');
    let addToCartBtn = document.querySelector('.vanity-add-to-cart');
    let spbProductOptionsWatchWrapper = document.querySelectorAll('.spb-productoptionswatchwrapper');
    let removeVanityOptions = document.querySelectorAll('.remove-vanity-option');

    if (!mainContainer) {
        return;
    }

    removeVanityOptions.forEach(item => {
        item.addEventListener('click', function () {
            // get aria label
            const label = item.closest('.sidebar-item').getAttribute('data-label');
            // item label
            const itemLabels = mainContainer.querySelectorAll('.spb-label-tooltip > label');
            itemLabels.forEach(itemLabel => {
                if (label === itemLabel.innerHTML) {
                    let checkboxes = itemLabel.parentNode.parentNode.querySelectorAll('input[type="checkbox"], input[type="radio"]');
                    let textInput = itemLabel.parentNode.parentNode.querySelectorAll('input[type="text"], input[type="number"], textarea');
                    if (checkboxes.length != 0) {
                        checkboxes.forEach(box => {
                            box.checked = false;
                            // remove disabled attribute
                            box.removeAttribute('disabled');
                        });

                        // remove
                        item.closest('.sidebar-item').querySelector('.sidebar-value').innerHTML = '';
                        item.closest('.sidebar-item').classList.add('d-none');
                    }
                    if (textInput.length != 0) {
                        textInput.forEach(input => {
                            input.value = '';
                        });
                        // remove
                        item.closest('.sidebar-item').querySelector('.sidebar-value').innerHTML = '';
                        item.closest('.sidebar-item').classList.add('d-none');
                    }
                }
            });
        });
    });

    // loop through all the radios and others
    options.forEach(item => {
        
        // onload
        optionsEvent(item);

        // event
        item.addEventListener('change', function () {
            optionsEvent(item);
            enableVanityButton();
        });

        // get type
        const type = item.getAttribute('type');
        if (type == 'text' || type == 'number' || type == 'email' || item.tagName.toLowerCase() === 'textarea') {
            // event
            item.addEventListener('keyup', function () {
                optionsEvent(item);
                enableVanityButton();
            });
        }
    });

    // loop through all the checkboxes
    optionsMultiple.forEach(item => {
        // wrap the text node in a span
        let wrapper = item.closest('label');
        let textNode = Array.from(wrapper.childNodes).find(node => node.nodeType === Node.TEXT_NODE);
        if (textNode) {
            // only get the text before the dash
            let labelText = textNode.textContent.split('|')[0].trim();
            let span = document.createElement('span');
            span.classList.add('spb-swatchlabel');
            span.textContent = labelText;
            wrapper.replaceChild(span, textNode);

            // append dash after the span if there was a dash
            if (textNode.textContent.includes('|')) {
                // get the rest of the text after the dash not including the dash
                let restText = textNode.textContent.substring(textNode.textContent.indexOf('|') + 1);
                let priceSpan = document.createElement('span');
                priceSpan.classList.add('spb-swatchprice');
                priceSpan.textContent = restText;
                wrapper.appendChild(priceSpan);
            }
        }

        // onload
        optionsMultipleEvent(item);

        // event
        item.addEventListener('change', function () {
            optionsMultipleEvent(item);
            // variantSelect(item);
            enableVanityButton();
        });
    });

    // options swatch radio
    if (optionsRadio.length > 0) {
        optionsRadio.forEach(item => {
            // wrap the text node in a span
            let wrapper = item.closest('label');
            let textNode = Array.from(wrapper.childNodes).find(node => node.nodeType === Node.TEXT_NODE);
            if (textNode) {
                // only get the text before the dash
                let labelText = textNode.textContent.split('|')[0].trim();
                let span = document.createElement('span');
                span.classList.add('spb-swatchlabel');
                span.textContent = labelText;
                wrapper.replaceChild(span, textNode);

                // append dash after the span if there was a dash
                if (textNode.textContent.includes('|')) {
                    // get the rest of the text after the dash not including the dash
                    let restText = textNode.textContent.substring(textNode.textContent.indexOf('|') + 1);
                    let priceSpan = document.createElement('span');
                    priceSpan.classList.add('spb-swatchprice');
                    priceSpan.textContent = restText;
                    wrapper.appendChild(priceSpan);
                }
            }

            // onload
            // selectEvent(item);

            // event
            item.addEventListener('change', function () {
                // variantSelect
                variantSelect(item);
                // alert('radio changed');
                enableVanityButton();
            });
        });
    }

    // spbProductOptionsWatchWrapper hover
    spbProductOptionsWatchWrapper.forEach(item => {
        // find spb-swatchlabel
        let swatchLabels = item.querySelector('.spb-swatchlabel');
        let swatchPrices = item.querySelector('.spb-swatchprice');
        // on hover add swatchprice height to swatchlabel as bottom position
        item.addEventListener('mouseenter', function () {
            if (swatchPrices && swatchLabels) {
                let priceHeight = swatchPrices.offsetHeight;
                swatchLabels.style.bottom = `${priceHeight}px`;
            } else if (swatchLabels) {
                swatchLabels.style.bottom = `2px`;
            }
        });
        item.addEventListener('mouseleave', function () {
            if (swatchLabels) {
                swatchLabels.style.bottom = '';
            }
        });
    });

    function optionsEvent(item) {

        // get type
        const type = item.getAttribute('type');
        // get the label
        const label = item.closest('div').querySelector('.spb-label-tooltip label').innerHTML;

        if (!label) {
            return;
        }

        setTimeout(() => {

            // let value = item.value
            let value;

            if ( type == 'radio' && item.checked ) {
                value = item.value;
            } else if ( type != 'radio') {
                value = item.value;
            } else {
                // break;
                value = false;
            }


            // find the sidebar-item with data-label
            const sidebarItem = document.querySelector(`.sidebar-item[data-label="${label}"]`);
            if (sidebarItem && value) {
                // only get the value before the dash
                value = value.split('|')[0].trim();
                // remove d-none
                sidebarItem.classList.remove('d-none');
                // set the value
                sidebarItem.querySelector('.sidebar-value').innerHTML = value;
            } else if (sidebarItem && value.length == 0) {
                // add d-none
                sidebarItem.classList.add('d-none');
                sidebarItem.querySelector('.sidebar-value').innerHTML = '';
            }
        }, 200);
    }

    // for checkboxes
    function optionsMultipleEvent(item) {
        // get the label
        const label = item.closest('div').querySelector('.spb-label-tooltip label').innerHTML;

        if (!label) {
            return;
        }

        setTimeout(() => {

            let values = [];

            // get all the checkboxes
            const checkboxes = item.closest('.swatch-item-content').querySelectorAll('input[type="checkbox"]');
            // loop through all the checkboxes
            checkboxes.forEach(checkbox => {
                if (checkbox.checked) {
                    // only get the value before the dash
                    values.push(checkbox.value.split('|')[0].trim());
                }
            });

            // find the sidebar-item with data-label
            const sidebarItem = document.querySelector(`.sidebar-item[data-label="${label}"]`);

            if (sidebarItem && values.length > 0) {
                // remove d-none
                sidebarItem.classList.remove('d-none');
                // set the value
                sidebarItem.querySelector('.sidebar-value').innerHTML = values.join(', ');
            } else {
                // add d-none
                sidebarItem.classList.add('d-none');
                sidebarItem.querySelector('.sidebar-value').innerHTML = '';
            }
        }, 200);

        // check if label exists in variants
        let formLabels = document.querySelectorAll('.form__label');
        formLabels.forEach(formLabel => {
            if (formLabel.innerHTML.trim() === label.trim()) {
                variantSelect(item);
            }
        });
    }

    // for variant selections
    function variantSelect(item) {
        // get value
        let value = item.value;
        // only keep the value before the dash
        value = value.split('|')[0].trim();
        // check if there is a variant with the value and select it from the variant-selects
        // let variantSelects = document.querySelectorAll('variant-selects input[type="radio"]');
        let variantSelects = document.querySelectorAll('variant-selects select');
        // check if there are variant selects
        if (variantSelects.length === 0) {
            return;
        }
        // loop through all the variant selects
        variantSelects.forEach(variant => {
            // find matching option
            let matched = null;
            Array.from(variant.options).forEach(opt => {
                const optVal = (opt.value || '').split('|')[0].trim();
                if (optVal === value) {
                    matched = opt;
                }
            });

            if (!matched) return;

            // set selected attribute for select
            variant.value = matched.value;
            matched.selected = true;

            // fire change so Shopify's theme JS updates price, media, etc.
            const evt = new Event('change', { bubbles: true });
            variant.dispatchEvent(evt);
        });
    }

    // select events
    function selectEvent(item) {

        // get the label
        const label = item.parentNode.parentNode.parentNode.querySelector('.spb-label-tooltip label').innerHTML;

        if (!label) {
            return;
        }
        
        // get selected value
        const selectedValue = item.options[item.selectedIndex].text;
        // find the sidebar-item with data-label
        const sidebarItem = document.querySelector(`.sidebar-item[data-label="${label}"]`);
        if (sidebarItem && selectedValue) {
            // only get the value before the dash
            let displayValue = selectedValue.split('|')[0].trim();
            // remove d-none
            sidebarItem.classList.remove('d-none');
            // set the value
            sidebarItem.querySelector('.sidebar-value').innerHTML = displayValue;
        }
    }
    
    // vanity button add to cart button click
    if (addToCartBtn) {
        if (!addToCartBtn.classList.contains('disabled')) {
            addToCartBtn.addEventListener('click', function (e) {
                e.preventDefault();
                let addToCart = document.querySelector('.product-form__buttons button');
                let loadingSpinner = addToCartBtn.nextElementSibling;
                // disabled
                if (addToCart && !addToCart.disabled) {
                    // find the overlay .sp-validate-overlay
                    let validateOverlay = document.querySelector('.sp-validate-overlay');
                    if (validateOverlay) {
                        // simulate click on the overlay to trigger validation
                        validateOverlay.click();
                    } else {
                        addToCart.click();
                    }
                    loadingSpinner.classList.remove('hidden');
                } else {
                    // console.log(loadingSpinner);
                    loadingSpinner.classList.add('hidden');
                    alert('Please select all the options before adding to cart.');
                }
            });
        }
    }

    // add to cart button
    function enableVanityButton(){
        if (addToCartBtn && addToCartBtn.classList.contains('disabled')) {
            addToCartBtn.classList.remove('disabled');
        }
    }
};

/* let variantSelectButtons = document.querySelectorAll('variant-selects label');
variantSelectButtons.forEach(item => {
    item.addEventListener('click', function (e) {
        e.preventDefault();
        alert();
        console.log('variant label clicked');
        // stop scrolling to top
        // window.scrollTo(0, 0);
    });
}); */

// update price information
function updatePriceInfo() {
    setTimeout(() => {
        const priceContainer = document.querySelector('.infiniteoptions-price');
        const vanityPricesDiv = document.getElementById('vanity-prices');

        if (!priceContainer || !vanityPricesDiv) {
            return;
        }

        // initial sync
        vanityPricesDiv.innerHTML = `
            <div class="vanity-price-info">
                ${priceContainer.innerHTML}
            </div>
        `;

        // set up observer to watch for any changes in the price container
        const observer = new MutationObserver(() => {
            vanityPricesDiv.innerHTML = `
                <div class="vanity-price-info">
                    ${priceContainer.innerHTML}
                </div>
            `;
        });

        observer.observe(priceContainer, {
            childList: true,
            subtree: true,
            characterData: true
        });
    }, 100);
}

// swatch multiple select rules
function swatchMultipleSelect() {
    // return;
    let swatchLabels = document.querySelectorAll('.swatch-item-content .spb-productoptionswatchwrapper');
    // console.log(swatchLabels);
    swatchLabels.forEach(item => {   
        let checkboxes = item.closest('.swatch-item-content').querySelectorAll('input[type="checkbox"]');
        let checkbox = item.querySelector('input[type="checkbox"]');
        let parent = item.closest('.swatch-item');
        let parentLabel = parent.querySelector('.spb-label-tooltip label').innerHTML;

        // console.log(item);

        // click event
        item.addEventListener('click', function (e) {
            // alert('Please select only one option for ' + parentLabel + '.');
            setTimeout(() => {
                // check if checkbox is checked
                if (checkbox) {
                    if (checkbox.checked) {} else {
                        // check if the checkbox is disabled
                        if (checkbox.disabled) {

                            // fieldset
                            let fieldset = item.closest('fieldset');
                            let siblings = fieldset.querySelectorAll('input[type="checkbox"]');
                            siblings.forEach(sib => {
                                sib.checked = false;
                                // remove disabled attribute
                                sib.removeAttribute('disabled');
                            });

                            // checkbox parent label
                            checkbox.closest('label').click();
                        }
                    }
                }

            }, 100);
        });
    });
}

// corner cart
function whenCornerReady(callback) {
  if (window.corner && typeof corner.on === 'function') {
    callback();
  } else {
    setTimeout(() => whenCornerReady(callback), 100);
  }
}

whenCornerReady(() => {
  corner.on("onCartEdit", (params) => {
    hideLoaderVanityAddToCartButton();
  });
});


// vanity builder add to cart button
function hideLoaderVanityAddToCartButton(){
    let addToCartBtn = document.querySelector('.vanity-add-to-cart');
    if (!addToCartBtn) {
        return;
    }
    let loadingSpinner = addToCartBtn.nextElementSibling;
    loadingSpinner.classList.add('hidden');
}

// product page enquire button product view
const productModalView = () => {
    const productEnquiryBtn = document.getElementById('productEnquiryBtn');

    if (!productEnquiryBtn) {
        return;
    }

    // onclick
    productEnquiryBtn.addEventListener('click', function (e) {
        e.preventDefault();

        // delay so the form can render
        setTimeout(() => {

            let title = document.querySelector('.product__info-container h1') ? document.querySelector('.product__info-container h1').innerHTML : "";
            let sku = document.querySelector('.product__info-container .sku') ? document.querySelector('.product__info-container .sku').innerHTML : "";
            let image = document.querySelector('.gallery-main .keen-slider__slide:first-child img') ? document.querySelector('.gallery-main .keen-slider__slide:first-child img').src : "";
            let productView = document.getElementById('product-view');

            if ( !productView ) {
                return;
            }

            if (!title || !sku || !image) {
                return;
            }

            // build the html
            const html = `
                <div class="d-block p-3" style="background-color:#f1f1f1">
                    <div class="row align-items-center gap-3">
                        <div class="col-auto position-relative pe-0">
                            <div class="featured-image flex-shrink-0" style="height:71px;width:71px;overflow:hidden;">
                                <img src="${image}" class="img-fluid h-100 w-100 object-fit-cover" alt="${title}">
                            </div>
                        </div>
                        <div class="col">
                            <div class="d-block text-start">
                                <div class="fs-md fw-bold lh-base">${title}</div>
                                <div class="fs-sm">
                                    <span class="text-gray">SKU:</span>
                                    <span class="text-gray">${sku}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            `;

            // append the html to the product view
            productView.innerHTML = html;
        }, 100);
    });
};

// sticky media
function stickyMedia(){
    const mediaSticky = document.querySelector('.media-sticky');
    if (mediaSticky) {
        // Apply sticky positioning with correct spacing
        mediaSticky.classList.add('position-sticky');
        mediaSticky.style.top = `${document.getElementById('header').offsetHeight + 20}px`;
    }
}
// show buy buttons
function showBuyButtons(){
    const productForm = document.querySelector('.product-form > form');
    if (productForm) {
        productForm.classList.remove('d-none');
    }
}

// init after load
// https://infinite-options.docs.theshoppad.com/developer-resources/event-api
// Create "window.Shoppad.apps.infiniteoptions" object if it doesn't already exist
"Shoppad.apps.infiniteoptions".split(".").reduce(function(o, x) { if (!o[x]) {o[x] ={};} return o[x] }, window);
// Define beforeReady callback
window.Shoppad.apps.infiniteoptions.beforeReady = function(subscribe) {
    subscribe('appLoad', function(event) {
        setTimeout(() => {
            vanityBuilder();
            updatePriceInfo();
        }, 1000);
    });
    subscribe('validationFail', function(event) {
        setTimeout(() => {
            hideLoaderVanityAddToCartButton();
        }, 1000);
    });
    subscribe('validationSuccess', function(event) {
        setTimeout(() => {
            hideLoaderVanityAddToCartButton();
        }, 1000);
    });
    
};
document.addEventListener("DOMContentLoaded", function () {
    // init
    productModalView();
    stickyMedia();

    // check if infiniteoptions-container has content
    const infiniteOptionsContainer = document.querySelector('#infiniteoptions-container .infiniteoptions-sidebar');
    // console.log(infiniteOptionsContainer.innerHTML.trim().length);
    if (!infiniteOptionsContainer) {
        showBuyButtons();
    }
});

//   product__info-wrapper grid__item
const productImageZoom = () => {
    const images = document.querySelectorAll('.gallery-main img');
    const paneContainer = document.querySelector('.product__info-wrapper');

    if (!paneContainer) {
        return;
    }

    images.forEach(image => {
        const drift = new Drift(image, {
            paneContainer: paneContainer,
            inlinePane: false,
            hoverBoundingBox: true,
        });
    });
};

// productImageZoom();

// remove .show class from the .mega-canvas if clicked outside of its element
document.addEventListener('click', function (e) {
    const megaCanvas = document.querySelector('.mega-canvas');

    if (megaCanvas && megaCanvas.classList.contains('show') && !megaCanvas.contains(e.target)) {
        // megaCanvas.classList.remove('show');
        // trigger click data-bs-toggle="offcanvas"
        const offCanvas = document.querySelector('.btn-close[data-bs-dismiss="offcanvas"]');
        if (offCanvas && !offCanvas.contains(e.target)) {
            offCanvas.click();
            console.log('Offcanvas clicked');
        }
    }
    /* 
    if (megaCanvas && !megaCanvas.contains(e.target)) {
        megaCanvas.classList.remove('show');
    } */

});